// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".solution-category[data-v-4c74debe]{padding:0}.solution-category .category-items[data-v-4c74debe]{border-bottom:1px solid #f8f8f8}.solution-category .item-details[data-v-4c74debe]{padding:25px;background-color:#f8f8f8}", ""]);
// Exports
module.exports = exports;
